/* __next_internal_client_entry_do_not_use__ StatsItem,default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { getTestProps } from 'lib/testing/utils';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { useBackgroundColor } from 'lib/context/BackgroundColorContext';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const StatsItem = (props)=>{
    const isEditing = useIsEditing();
    const { fields } = props;
    const { uid } = props?.rendering || {};
    const { container, numberWrapper, number, description, title } = TAILWIND_VARIANTS();
    const statsId = `stats-${uid}`;
    const { backgroundColor } = useBackgroundColor();
    return /*#__PURE__*/ _createElement("div", {
        className: container({
            backgroundColor
        }),
        "data-component": "authorable/shared/lists/statsitem",
        ...editingHydrationProps(isEditing),
        key: statsId,
        ...getTestProps(`stats-item-${statsId}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: numberWrapper(),
                children: /*#__PURE__*/ _jsx(PlainTextWrapper, {
                    field: fields?.number,
                    ...getTestProps(`number`),
                    tag: "span",
                    className: number()
                })
            }),
            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                className: title(),
                field: fields?.title,
                ...getTestProps(`title`)
            }),
            /*#__PURE__*/ _jsx(RichTextWrapper, {
                className: description(),
                field: fields?.description,
                ...getTestProps(`description`)
            })
        ]
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'flex',
            'flex-col',
            'py-spacing-spacing-48',
            'px-spacing-spacing-32',
            'gap-spacing-spacing-16',
            'rounded-general-border-radius-card',
            'h-full'
        ],
        title: [
            'w-full',
            'text-component-stat-label',
            'text-typography-font-size-body-xlarge',
            'font-typography-font-family-body',
            'leading-typography-line-height-body-xlarge',
            'font-semibold'
        ],
        numberWrapper: [
            'w-full',
            'text-component-stat-number'
        ],
        number: [
            'font-typography-font-family-header',
            'text-typography-font-size-display',
            'leading-typography-line-height-display',
            'text-component-stat-number',
            'font-normal'
        ],
        description: [
            'w-full',
            'text-component-stat-description',
            'text-typography-font-size-body-medium',
            'font-typography-font-family-body',
            'leading-typography-line-height-body-medium',
            'font-normal'
        ]
    },
    variants: {
        backgroundColor: {
            Default: {
                container: [
                    'bg-component-stat-surface',
                    'shadow-[0_0_8px_0_var(--color-black-alpha-10)]'
                ]
            },
            Transparent: {
                container: [
                    'bg-transparent',
                    'shadow-none'
                ]
            }
        }
    },
    defaultVariants: {
        backgroundColor: 'Default'
    }
});
const StatsItemWrapped = withStandardComponentWrapper(StatsItem);
export { StatsItemWrapped as StatsItem };
export default StatsItemWrapped;
